export const debug = (message: string) => {
  if(process.env.REACT_APP_ENV !== 'production') {
    console.debug(message)
  }
}